import { Rule } from "antd/lib/form";

export const hourPattern: Rule = {
	pattern: /^\d{2}.\d{2}$/g,
	message: "Esse campo requer um hora válido",
};
